import { APICallV3Post, APICallV4Post } from 'reactApp/api/APICall';

export class R7ViewApiAPICallV3 extends APICallV3Post {
    _method = 'r7/view';
}

export class R7ViewApiAPICallV4 extends APICallV4Post {
    _method = 'r7/view';
}
